<template>
    <div v-if="computedStores.length > 0">
        <div v-if="isSection">
            <div class="store-select-section">
                {{ $t('pickup.location') }}
            </div>
            <div
                v-if="isError && !value"
                class="input-error store-select-section-error">
                {{ $t('x.required.message', {x: $t('pickup.location')}) }}
            </div>
        </div>
        <LabelWithError
            v-else
            :label="$t('pickup.location') + '*'"
            :error="
                isError && !value
                    ? $t('x.required.message', {x: $t('pickup.location')})
                    : ''
            " />

        <div class="store-select-grid">
            <span
                v-for="store in computedStores"
                :key="store.id"
                class="store-select-item"
                v-on:click="select(store.id)">
                <LabelSelect
                    fill-selected
                    class="uk-height-1-1"
                    :is-error="isError && !value"
                    :is-selected="value === store.id">
                    <div class="uk-flex uk-flex-center uk-margin-small-top">
                        <div
                            v-if="store.image"
                            :data-src="getImageLink(store)"
                            class="store-select-image uk-background-cover"
                            uk-img />
                        <div
                            v-else
                            class="store-select-image store-select-initials">
                            {{ getInitials(store.name) }}
                        </div>
                    </div>

                    <div class="uk-text-center store-select-name">
                        {{ store.name }}
                    </div>
                    <div class="uk-text-center store-select-line">
                        {{ store.street }}
                    </div>
                    <div class="uk-text-center store-select-line">
                        {{ store.zip }} {{ store.city }}
                    </div>
                    <div
                        v-if="store.telephone"
                        class="uk-text-center store-select-line uk-margin-small-bottom">
                        {{ store.telephone }}
                    </div>
                </LabelSelect>
            </span>
        </div>

        <div class="uk-margin-bottom" />
    </div>
</template>

<script>
import LabelSelect from '@/components/LabelSelect.vue';
import LabelWithError from '@/components/generic/LabelWithError.vue';

export default {
    name: 'StoreSelect',
    components: {LabelSelect, LabelWithError},
    props: {
        value: String,
        isError: Boolean,
        isSection: Boolean,
    },
    computed: {
        computedStores() {
            if (this.isTerminalMode) {
                return [];
            }

            return this.getInfos.stores ? this.getInfos.stores : [];
        },
    },
    methods: {
        select(id) {
            this.$emit('input', id);
        },
        getImageLink(store) {
            return (
                this.apiUrl + '/stores/' + store.id + '/image/' + store.image
            );
        },
        getInitials(name) {
            if (!name) {
                return '?';
            }

            return name
                .trim()
                .split(/\s+/)
                .slice(0, 2)
                .map((word) => word[0].toUpperCase())
                .join('');
        },
    },
};
</script>

<style lang="scss" scoped>
.store-select-section {
    font-size: 18px;
    font-weight: 500;
    color: $site-background;
    margin-bottom: 10px;
}

.store-select-section-error {
    color: $danger-color;
    margin-top: -6px;
    margin-bottom: 10px;
}

.store-select-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.store-select-item {
    flex: 1 1 100%;
    cursor: pointer;
}

@media (min-width: 640px) {
    .store-select-item {
        flex-basis: calc(50% - 5px);
    }
}

@media (min-width: 960px) {
    .store-select-item {
        flex-basis: calc(33.333% - 7px);
    }
}

.store-select-image {
    height: 140px;
    width: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.store-select-initials {
    background-color: #14183b;
    color: #fff;
    font-size: 1.75rem;
    font-weight: 500;
    letter-spacing: 0.05em;
    user-select: none;
}

.store-select-name {
    font-size: 16px;
    font-weight: 500;
    margin-top: 8px;
}

.store-select-line {
    font-size: 14px;
}
</style>
